import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IFastGalleryMapperProps,
  IFastGalleryControllerProps,
  IFastGalleryCompProps,
} from '../FastGallery.types';

export default withCompController<
  IFastGalleryMapperProps,
  IFastGalleryControllerProps,
  IFastGalleryCompProps
>(({ mapperProps, controllerUtils }) => {
  return {
    ...mapperProps,
    setIsExpanded: (isExpanded: boolean) => {
      controllerUtils.updateProps({ isExpanded });
    },
  };
});
